import { CasaviFilterElement, CasaviFilterType } from "@/api-schema-enums";

interface CasaviFilterFormSource {
  caseSensitive?: boolean | null;
  element?: string | null;
  type?: string | null;
  value?: string | null;
}

export interface CasaviFilterFormValues {
  caseSensitive: boolean;
  element: CasaviFilterElement;
  type: CasaviFilterType;
  value: string;
}

const defaultCasaviFilterFormValues: CasaviFilterFormValues = {
  caseSensitive: false,
  element: CasaviFilterElement.Id,
  type: CasaviFilterType.Full,
  value: "",
};

const normalizeEnumToken = (value: string): string => value.replace(/[\s_-]/g, "").toLowerCase();

const createNormalizedEnumMap = <TEnum extends Record<string, string>>(
  enumObject: TEnum,
): Map<string, TEnum[keyof TEnum]> => {
  const normalizedEntries = Object.entries(enumObject).flatMap(([key, value]) => {
    const enumValue = value as TEnum[keyof TEnum];

    return [
      [normalizeEnumToken(key), enumValue],
      [normalizeEnumToken(value), enumValue],
    ] as const;
  });

  return new Map(normalizedEntries);
};

const casaviFilterElementMap = createNormalizedEnumMap(CasaviFilterElement);
const casaviFilterTypeMap = createNormalizedEnumMap(CasaviFilterType);

export function normalizeCasaviFilterElement(value?: string | null): CasaviFilterElement | undefined {
  if (!value) {
    return undefined;
  }

  return casaviFilterElementMap.get(normalizeEnumToken(value));
}

export function normalizeCasaviFilterType(value?: string | null): CasaviFilterType | undefined {
  if (!value) {
    return undefined;
  }

  return casaviFilterTypeMap.get(normalizeEnumToken(value));
}

export function getCasaviFilterFormValues(source?: CasaviFilterFormSource | null): CasaviFilterFormValues {
  return {
    caseSensitive: source?.caseSensitive ?? defaultCasaviFilterFormValues.caseSensitive,
    element: normalizeCasaviFilterElement(source?.element) ?? defaultCasaviFilterFormValues.element,
    type: normalizeCasaviFilterType(source?.type) ?? defaultCasaviFilterFormValues.type,
    value: source?.value ?? defaultCasaviFilterFormValues.value,
  };
}
